import {
  transformedGatewaysWithMachinesListEntryTypes,
  MachinesListDataTypes,
} from "@common/types/machines-list-types";

const normalizeSearchTerms = (searchTerms: string[]): string[] =>
  searchTerms.map((term) => term.toLowerCase()).filter(Boolean);

const valueMatchesSearchTerm = (
  value: string | number | boolean | null | undefined,
  searchTermValue: string,
): boolean => {
  if (value == null) return false;
  return String(value).toLowerCase().includes(searchTermValue);
};

const sourceMatchesSearchTerms = (
  source: MachinesListDataTypes,
  companyName: string,
  normalizedSearchTerms: string[],
): boolean => {
  if (!normalizedSearchTerms.length) return false;

  const searchableValues = [
    source.name,
    source.source_id,
    source.dsn,
    source.vendor_id,
    companyName,
  ];

  return normalizedSearchTerms.every((term) =>
    searchableValues.some((value) => valueMatchesSearchTerm(value, term)),
  );
};

const updateGatewaySources = (
  gateway: transformedGatewaysWithMachinesListEntryTypes,
  sources: Record<string, MachinesListDataTypes>,
): transformedGatewaysWithMachinesListEntryTypes => ({
  ...gateway,
  sources,
  sources_visible: true,
});

export const findSearchedMachinesList = (
  data: Record<string, transformedGatewaysWithMachinesListEntryTypes>,
  searchTerms: string[],
): Record<string, transformedGatewaysWithMachinesListEntryTypes> => {
  const normalizedSearchTerms = normalizeSearchTerms(searchTerms);
  if (!normalizedSearchTerms.length) {
    return {};
  }

  const entries = Object.values(data ?? {});
  if (!entries.length) {
    return {};
  }

  const results: Record<string, transformedGatewaysWithMachinesListEntryTypes> =
    {};

  for (const companyEntry of entries) {
    const sources = companyEntry?.sources ?? {};
    const matchedSources: Record<string, MachinesListDataTypes> = {};
    let isMatching = false;
    for (const source of Object.values(sources)) {
      if (
        sourceMatchesSearchTerms(
          source,
          companyEntry.name,
          normalizedSearchTerms,
        )
      ) {
        matchedSources[source.source_id] = source;
        isMatching = true;
      }
    }
    if (isMatching) {
      results[companyEntry.name] = updateGatewaySources(
        companyEntry,
        matchedSources,
      );
    }
  }
  return results;
};
